import { Moment } from 'moment';

export default class DriveCheckInOut {
  date: Moment | null = null;
  mileage: number | null = null;
  fuelLevel: number | null = null;
  note = '';
}
